import DateMixins from '@/mixins/DateMixins'
import SiteMixins from '@/mixins/SiteMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [DateMixins, SiteMixins, NumberMixins]
}



// WEBPACK FOOTER //
// ./src/mixins/PermitMixins.js